export const environments = {
  DEV: 'dev',
  STG: 'stg',
  PROD: 'prod'
};

export const analysisStatuses = {
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
};

export const typeHistogram = {
  WEIGHT: 'WEIGHT',
  LENGTH: 'LENGTH',
  PIGMENTATION: 'PIGMENTATION',
  CONDITION_FACTOR: 'CONDITION_FACTOR',
  SURVIVAL_RATE: 'SURVIVAL_RATE',
};

export const analysisTypes = {
  GENERAL_LARVAE_ANALYSIS: 'GENERAL_LARVAE_ANALYSIS',
  GENERAL_JUVENILE_ANALYSIS: 'GENERAL_JUVENILE_ANALYSIS',
  GENERAL_ADULT_ANALYSIS: 'GENERAL_ADULT_ANALYSIS',
  CONSOLIDATED_LARVAE_ANALYSIS: 'CONSOLIDATED_LARVAE_ANALYSIS',
  CONSOLIDATED_JUVENILE_ANALYSIS: 'CONSOLIDATED_JUVENILE_ANALYSIS',
  CONSOLIDATED_ADULT_ANALYSIS: 'CONSOLIDATED_ADULT_ANALYSIS',
};

export const stockingPhaseTypes = {
  LARVAE: 'LARVAE',
  JUVENILE: 'JUVENILE',
  ADULT: 'ADULT',
};

export const weightUnits = {
  G: 'g',
  MG: 'mg'
};

export const lengthUnits = {
  CM: 'cm',
  MM: 'mm'
};

export const animalDaysUnit = {
  PL: 'PL',
  D: 'D'
};

export enum THEME {
  DARK = 'dark',
  LIGHT = 'light',
}
export const roundWeight = (params: { value: number | number[]; showUnit?: boolean; average?: number; forceCast?: boolean; decimalPlaces?: number }) => {
  const { value, showUnit = true, average = 0, forceCast = false, decimalPlaces = 2 } = params;

  const minValue = 100;
  const constantToConvert = 1000;
  const isArray = Array.isArray(value);

  if (isArray) {
    const arrayValue = value;
    if (average < minValue) {
      return arrayValue;
    }

    if (decimalPlaces === 3) {
      return arrayValue.map((weight: number) => roundThreeDecimals(weight / constantToConvert));
    }

    return arrayValue.map((weight: number) => roundTwoDecimals(weight / constantToConvert));
  }

  const numberValue = value;
  if (value >= minValue || forceCast) {
    let number = roundTwoDecimals(numberValue / constantToConvert);

    if (decimalPlaces === 3) {
      number = roundThreeDecimals(numberValue / constantToConvert);
      return showUnit ? `${number} ${weightUnits.G}` : number;
    }

    return showUnit ? `${number} ${weightUnits.G}` : number;
  }

  if (decimalPlaces === 3) {
    return showUnit ? `${roundThreeDecimals(numberValue)} ${weightUnits.MG}` : roundThreeDecimals(numberValue);
  }

  return showUnit ? `${roundTwoDecimals(numberValue)} ${weightUnits.MG}` : roundTwoDecimals(numberValue);
};

export const getWeightUnit = (average: number) => {
  if (average === 0) {
    return '';
  }

  const minValue = 100;

  if (average < minValue) {
    return weightUnits.MG;
  }

  return weightUnits.G;
};

export const roundLength = (params: { value: number | number[]; showUnit?: boolean; average?: number }) => {
  const { value, showUnit = true, average = 0 } = params;
  const minValue = 10;
  const constantToConvert = 10;
  const isArray = Array.isArray(value);

  if (isArray) {
    const arrayValue: any = value;
    if (average < minValue) {
      return arrayValue;
    }

    return arrayValue.map((length: number) => roundTwoDecimals(length / constantToConvert));

  } else {
    const numberValue: any = value;
    if (value >= minValue) {
      const number = roundTwoDecimals(numberValue / constantToConvert);
      return showUnit ? `${number} ${lengthUnits.CM}` : number;
    }

    return showUnit ? `${roundTwoDecimals(numberValue)} ${lengthUnits.MM}` : roundTwoDecimals(numberValue);

  }
};

export const getLengthUnit = (average: number) => {
  const minValue = 10;

  if (average < minValue) {
    return lengthUnits.MM;
  }

  return lengthUnits.CM;
};

export const roundOneDecimal = (value: number) => {
  return Math.round((value + Number.EPSILON) * 10) / 10;
};

export const roundTwoDecimals = (value: number) => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

export const roundThreeDecimals = (value: number) => {
  return Math.round((value + Number.EPSILON) * 1000) / 1000;
};

export const DEFAULT_DAYS_TO_INITIAL_STAGE = 7;
